<div [formGroup]="formGroup">
  <pas-system-process [cancelButton]="false" #processComponent></pas-system-process>
  <div class="overviewDetailsContainer">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      @if (isEditOrViewTabActive()) {
        <ng-container>
          <div>
            <h2>
              <b>{{ 'BOOKING_DETAILS_ID' | translate }} {{ formGroup.get('pkBookingId').value }}</b>
            </h2>
          </div>
          <div class="row g-4">
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_STATUS' | translate }}</b>
              </label>
              <label id="bookingDetailStatusLblValue">{{ formGroup.get('status').value }}</label>
            </div>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_RECOURSE_TYPE' | translate }}</b>
              </label>
              <label id="bookingDetailRecourseTypeLblValue">{{ recourseTypeLabel }}</label>
            </div>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_CREATED_ON' | translate }}</b>
              </label>
              <label>{{ formGroup.get('createDate').value | date: dateFormatPipe.getDateFormatGerman() }}</label>
            </div>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_CREATOR' | translate }}</b>
              </label>
              <label>{{ formGroup.get('creator').value }}</label>
            </div>
          </div>
          <!-- Show customer error messages -->
          @if (selectedBookingDetails) {
            <ng-container>
              @for (customerErrorMessage of errorMessages; track customerErrorMessage) {
                <div>
                  <span class="red-bold-large">{{ customerErrorMessage | translate }}</span>
                </div>
              }
            </ng-container>
          }
          <!-- Show booking state failed message -->
          @if (bookingStateBlockedOrFailed) {
            <ng-container>
              <div>
                <span class="red-bold-large">
                  {{ 'STATUS_REASON_TEXT_PREFIX' | translate }}{{ bookingStateReasonLabel }}
                </span>
              </div>
            </ng-container>
          }
        </ng-container>
      }
      <!-- Show customer error messages -->
      @if (isNewTabActive()) {
        <ng-container>
          @for (errorMessage of errorMessages; track errorMessage) {
            <div>
              <span class="red-bold-large">{{ errorMessage | translate }}</span>
            </div>
          }
        </ng-container>
      }
      <!-- Show booking rejection comment -->
      @if (bookingRejectionCommentVisible) {
        <ng-container>
          <div class="row g-4">
            <div class="col-3">
              <label style="color: red">
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_DIALOG_CAUSE_OF_REJECTION' | translate }}</b>
              </label>
              <label style="color: red">
                {{ bookingApprovalsHistory[bookingApprovalsHistory.length - 1].comment }}
              </label>
            </div>
          </div>
        </ng-container>
      }

      <pas-accordion
        [isClosed]="false"
        id="first-accordion"
        title="{{ 'BOOKING_DETAILS_EXTERNAL_RECEIVER' | translate }}">
        <ng-template pasAccordionBody>
          <div class="row justify-content-between">
            <pas-input
              [maxLength]="6"
              [formControl]="$any(formGroup.get('supplier'))"
              (ngModelChange)="onSupplierChanged()"
              class="col-3"
              subLabel="{{ 'BOOKING_DETAILS_SUPPLIER' | translate }}"
              formControlName="supplier"></pas-input>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_DEBITOR' | translate }}</b>
              </label>
              <label>{{ debitor }}</label>
            </div>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_NAME' | translate }}</b>
              </label>
              <label>{{ formGroup.get('name').value }}</label>
            </div>
            <div class="col-3">
              <label>
                <b>{{ 'BOOKING_DETAILS_CITY' | translate }}</b>
              </label>
              <label>{{ formGroup.get('city').value }}</label>
            </div>
          </div>
        </ng-template>
      </pas-accordion>

      <pas-accordion [isClosed]="false" id="second-accordion" title="{{ 'BOOKING_DETAILS_GENERAL_INFO' | translate }}">
        <ng-template pasAccordionBody>
          <div class="row justify-content-start align-items-end">
            <pas-select
              [(ngModel)]="selectedBookingType"
              [options]="bookingTypeDropdownValues"
              [formControl]="$any(formGroup.get('bookingTypeDropdown'))"
              (ngModelChange)="onSelectBookingType(bookingTypeDropdownSelect.selectedOption)"
              class="col-5"
              id="bookingTypeDropdownSelect"
              #bookingTypeDropdownSelect
              placeholder="{{ 'CHOOSE_ONE' | translate }}"
              subLabel="{{ 'BOOKING_DETAILS_BOOKING_TYPE' | translate }}"></pas-select>
            <pas-input
              [formControl]="$any(formGroup.get('invoiceReasonText'))"
              [maxLength]="250"
              class="col-7"
              subLabel="{{ 'BOOKING_DETAILS_INVOICE_REASON' | translate }}"
              placeholder="{{ (isNewTabActive() ? 'COMMENT_INVOICE_REASON' : null) | translate }}"
              formControlName="invoiceReasonText"></pas-input>
          </div>
          <br />
          <div class="row">
            <div class="col-5">
              @if (isNewTabActive()) {
                <ng-container>
                  <div class="row justify-content-start">
                    <pas-select
                      [(ngModel)]="selectedRecourseType"
                      [options]="recourseTypeDropdownValues"
                      [formControl]="$any(formGroup.get('recourseTypeDropdown'))"
                      (ngModelChange)="onSelectRecourseType(bookingRecourseTypeDropdownSelect.selectedOption)"
                      class="col"
                      id="bookingRecourseTypeDropdownSelect"
                      #bookingRecourseTypeDropdownSelect
                      placeholder="{{ 'CHOOSE_ONE' | translate }}"
                      subLabel="{{ 'BOOKING_DETAILS_RECOURSE_TYPE' | translate }}"></pas-select>
                  </div>
                  <br />
                  @if (isSelectedRaDType()) {
                    <ng-container>
                      <div class="row justify-content-start">
                        <pas-input
                          [formControl]="$any(formGroup.get('revenueOrderNumber'))"
                          [maxLength]="10"
                          class="col"
                          subLabel="{{ 'BOOKING_DETAILS_REVENUE_ORDER_NUMBER' | translate }}"
                          formControlName="revenueOrderNumber"></pas-input>
                      </div>
                      <br />
                    </ng-container>
                  }
                </ng-container>
              } @else {
                @if (selectedBookingDetails?.recourseTypeId === 3) {
                  <ng-container>
                    <div class="row justify-content-start">
                      <pas-input
                        [formControl]="$any(formGroup.get('revenueOrderNumber'))"
                        [maxLength]="10"
                        class="col"
                        subLabel="{{ 'BOOKING_DETAILS_REVENUE_ORDER_NUMBER' | translate }}"
                        formControlName="revenueOrderNumber"></pas-input>
                    </div>
                    <br />
                  </ng-container>
                }
              }

              <ng-container>
                <div class="row justify-content-start">
                  <pas-textarea
                    [maxLength]="compCommentCharactersMaxLength"
                    [formControl]="$any(formGroup.get('bookingJustificationComment'))"
                    (ngModelChange)="onCommentChanged()"
                    class="col-12"
                    id="comment"
                    subLabel="{{ 'BOOKING_DETAILS_BOOKING_JUSTIFICATION_COMMENT' | translate }}"></pas-textarea>
                  <div style="padding-left: 20px">
                    <label class="infoDiv">{{ 'BOOKING_DETAILS_COMMENT_CHARACTER_LEFT' | translate }}</label>
                    <label class="infoDiv">{{ compCommentCharactersLeft }}</label>
                  </div>
                </div>
              </ng-container>
              <br />
            </div>

            <div class="col-7">
              @for (item of partialPaymentFormArray.controls; track item; let i = $index) {
                <div formArrayName="partialPaymentItems">
                  <div [formGroupName]="i">
                    <div class="row">
                      <pas-input-number
                        [hasClearBtn]="false"
                        [decimalCount]="2"
                        [decimalSeparator]="decimalSeparator"
                        [maxLength]="14"
                        [formControl]="$any(item.get('amount'))"
                        (ngModelChange)="onAmountChanged(i)"
                        class="col-4 pull-right"
                        id="amount-{{ i }}"
                        subLabel="{{ 'BOOKING_DETAILS_NET_AMOUNT' | translate }}"
                        formControlName="amount"></pas-input-number>
                      @if (i === 0) {
                        <pas-select
                          [(ngModel)]="selectedEditorCurrency"
                          [options]="editorCurrencyDropdownValues"
                          [formControl]="$any(item.get('editorCurrency'))"
                          (ngModelChange)="onSelectEditorCurrency(editorCurrencySelection.selectedOption)"
                          class="col-4"
                          id="editorCurrency-{{ i }}"
                          #editorCurrencySelection
                          subLabel="{{ 'BOOKING_DETAILS_CURRENCY' | translate }}"
                          placeholder="{{ 'CHOOSE_ONE' | translate }}"></pas-select>
                      }
                      @if (i > 0) {
                        <pas-input
                          [(ngModel)]="selectedEditorCurrency.key"
                          [formControl]="$any(item.get('editorCurrency'))"
                          class="col-4"
                          id="editorCurrency-input"
                          style="padding-left: 15px"
                          subLabel="{{ 'BOOKING_DETAILS_CURRENCY' | translate }}"></pas-input>
                      }
                      @if (explicitPaymentTarget) {
                        <pas-datetime-picker
                          [formControl]="$any(item.get('dueDate'))"
                          [validationMessages]="validationMessages"
                          class="col-3"
                          id="dueDate-{{ i }}"
                          pickerType="date"
                          locale="de"
                          subLabel="{{ 'BOOKING_DETAILS_DUE_DATE' | translate }}"
                          confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
                      }
                      @if (i !== 0 && isNewTabActive()) {
                        <pas-button
                          (click)="removeFormItem(i)"
                          class="partial-payment-button delete"
                          class="col-1"
                          id="deletePartialPaymentRow-{{ i }}"
                          icon="close"></pas-button>
                      }
                      <br />
                    </div>
                    <div class="row">
                      <div class="col-12">
                        @if (referringCurrencyVisible[i]) {
                          <label
                            class="select-control calculated-amount"
                            id="calculatedAmount-{{ i }}"
                            style="margin-left: 16px">
                            {{ formattedCalculatedAmount[i] }}
                          </label>
                        }
                        @if (!referringCurrencyVisible[i]) {
                          <label
                            class="select-control calculated-amount-not-visible"
                            id="calculatedAmount-{{ i }}"
                            style="margin-left: 16px"></label>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div class="row">
                <div class="col-4"></div>
                <pas-checkbox
                  [formControl]="$any(formGroup.get('explicitPayment'))"
                  [attr.disabled]="partialPaymentFormArray.controls.length > 1 || isViewTabActive()"
                  (ngModelChange)="onExplicitPaymentTargetChanged()"
                  class="col"
                  formControlName="explicitPayment"
                  label="{{ 'EXPLICIT_PAYMENT_TARGET' | translate }}"
                  size="small"></pas-checkbox>
                @if (isNewTabActive()) {
                  <pas-button
                    (click)="addNewFormItem()"
                    class="col"
                    icon="add_circle"
                    text="{{ 'BOOKING_DETAILS_PARTIAL_PAYMENT' | translate }}"></pas-button>
                }
              </div>

              <div class="row">
                <div class="col">
                  @if (partialPaymentFormArray.controls.length > 1) {
                    <label
                      class="select-control total-calculated-amount-label"
                      id="totalCalculatedAmountVisibleLabel"
                      style="margin-left: 16px">
                      <b>{{ 'BOOKING_DETAILS_TOTAL_CALCULATED_AMOUNT' | translate }}</b>
                    </label>
                  }
                  @if (partialPaymentFormArray.controls.length > 1) {
                    <label
                      class="select-control total-calculated-amount"
                      id="totalCalculatedAmountVisible"
                      style="margin-left: 16px">
                      <b>{{ formattedTotalCalculatedAmount }}</b>
                    </label>
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </pas-accordion>

      @if (isEditOrViewTabActive()) {
        <ng-container>
          <pas-accordion
            [isClosed]="referenceAccordionClosed"
            id="third-accordion"
            title="{{ 'REFERENCE_BOOKINGS' | translate }}">
            <ng-template pasAccordionBody>
              <reference-bookings [referenceBookings]="referenceBookings"></reference-bookings>
            </ng-template>
          </pas-accordion>
        </ng-container>
      }
      @if (isEditOrViewTabActive()) {
        <ng-container>
          <pas-accordion
            [isClosed]="bookingApprovalsHistoryAccordionClosed"
            id="fourth-accordion"
            title="{{ 'BOOKING_APPROVAL_HISTORY' | translate }}">
            <ng-template pasAccordionBody>
              <app-booking-approvals-history
                [bookingApprovalsHistory]="bookingApprovalsHistory"
                #approvalsHistoryComponent></app-booking-approvals-history>
            </ng-template>
          </pas-accordion>
        </ng-container>
      }

      <pas-accordion
        [isClosed]="bookingAttachmentsAccordionClosed"
        id="fifth-accordion"
        title="{{ 'BOOKING_DETAILS_ATTACHMENTS' | translate }}">
        <ng-template pasAccordionBody>
          <app-booking-attachments
            [bookingAttachments]="attachments"
            [isNewTabActive]="isNewTabActive()"
            (deleteAttachment)="onAttachmentDeletion()"
            #bookingAttachmentsComponent></app-booking-attachments>
        </ng-template>
      </pas-accordion>
    </div>
  </div>

  <!-- Template for reusable revenue order number input field, had to be put inside parent formGroup -->
</div>
<pas-notifications></pas-notifications>

@if (isEditOrViewTabActive() || isNewTabActive()) {
  <ng-container>
    <pas-sidebar-holder [hasNavbar]="true">
      <div class="sidebar-contents">
        <ng-container>
          <div class="sidebar-element sidebar-row">
            <ul class="navbar-nav">
              @if (isEditTabActive() || isNewTabActive()) {
                <ng-container>
                  <li [ngClass]="isSaveButtonEnabled() ? 'nav-item' : 'nav-item disabled'">
                    <a
                      [style.cursor]="formChanged && formGroup.valid ? 'pointer' : 'default'"
                      [attr.disabled]="!formChanged && formGroup.invalid"
                      [attr.aria-disabled]="!formChanged && formGroup.invalid"
                      (click)="isSaveButtonEnabled() ? onBtnSave() : false"
                      class="nav-link link-sidebar">
                      <i class="material-icons">save</i>
                      <span class="hidden-md-down" ui-test-id="saveBookingBtn">{{ 'SAVE' | translate }}</span>
                    </a>
                  </li>
                </ng-container>
              }
              <li [ngClass]="'nav-item'">
                <a (click)="onBtnCancel()" class="nav-link link-sidebar">
                  <i class="material-icons">cancel</i>
                  <span class="hidden-md-down" ui-test-id="cancelBtn">{{ 'CANCEL' | translate }}</span>
                </a>
              </li>
              @if (canUserDoCorrectionBooking()) {
                <ng-container>
                  <li [ngClass]="isBookingLoaded() ? 'nav-item' : 'nav-item disabled'">
                    <a
                      [class.disabled]="!isBookingLoaded()"
                      (click)="isBookingLoaded() ? createCorrectionBooking() : noop()"
                      class="nav-link link-sidebar">
                      <i class="material-icons">add_circle_outline</i>
                      <span class="hidden-md-down" ui-test-id="createCorrectionBookingBtn">
                        {{ 'BOOKING_DETAILS_CREATE_CORRECTION_BOOKING' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
              @if (canUserCancelBooking() && isSignatureOk()) {
                <ng-container>
                  <li [ngClass]="'nav-item'">
                    <a (click)="onBtnCancelBooking()" class="nav-link link-sidebar">
                      <i class="material-icons">delete</i>
                      <span class="hidden-md-down" ui-test-id="cancelBookingBtn">
                        {{ 'CANCEL_BOOKING_BUTTON' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
              @if (isSignatureOk() && !startApprovalBtnHidden) {
                <ng-container>
                  <li [ngClass]="isStartApprovalButtonEnabled() ? 'nav-item' : 'nav-item disabled'">
                    <a
                      [class.disabled]="!isStartApprovalButtonEnabled()"
                      [style.cursor]="formChanged && formGroup.valid ? 'pointer' : 'default'"
                      [attr.disabled]="!formChanged && formGroup.invalid"
                      [attr.aria-disabled]="!formChanged && formGroup.invalid"
                      (click)="isStartApprovalButtonEnabled() ? onBtnStartApproval() : false"
                      class="nav-link link-sidebar">
                      <i class="material-icons">playlist_play</i>
                      <span class="hidden-md-down" ui-test-id="startApprovalBtn">
                        {{ 'START_APPROVE_PROCESS_BUTTON' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
              @if (isViewTabActive() && canUserApprove()) {
                <ng-container>
                  <li [ngClass]="'nav-item'">
                    <a (click)="onBtnApproveBooking()" class="nav-link link-sidebar">
                      <i class="material-icons">done</i>
                      <span class="hidden-md-down" ui-test-id="approveBookingBtn">
                        {{ 'BOOKING_DETAILS_APPROVE_BOOKING' | translate }}
                      </span>
                    </a>
                  </li>
                  <li [ngClass]="'nav-item'">
                    <a (click)="onBtnRejectBooking()" class="nav-link link-sidebar">
                      <i class="material-icons">clear</i>
                      <span class="hidden-md-down" ui-test-id="rejectBookingBtn">
                        {{ 'BOOKING_DETAILS_REJECT_BOOKING' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
              @if (canUserUploadAttachments()) {
                <ng-container>
                  <li [ngClass]="createDeleteAttachmentAllowed() ? 'nav-item' : 'nav-item disabled'">
                    <a (click)="onUploadAttachments()" class="nav-link link-sidebar">
                      <i class="material-icons">file_upload</i>
                      <span class="hidden-md-down" ui-test-id="uploadAttachmentBtn">
                        {{ 'UPLOAD_ATTACHMENT' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
              @if (canUserReprocess()) {
                <ng-container>
                  <li [ngClass]="isUserReprocessEnabled() ? 'nav-item' : 'nav-item disabled'">
                    <a (click)="onBtnReprocessBooking()" class="nav-link link-sidebar">
                      <i class="material-icons">settings_backup_restore</i>
                      <span class="hidden-md-down" ui-test-id="bookingReprocessBtn">
                        {{ 'BOOKING_DETAILS_REPROCESS' | translate }}
                      </span>
                    </a>
                  </li>
                </ng-container>
              }
            </ul>
          </div>
        </ng-container>
      </div>
    </pas-sidebar-holder>
  </ng-container>
}

<ng-template #UploadFileDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="acceptanceAllowed"
    (confirm)="onAcceptUploadFileDialog()"
    (cancel)="onCloseUploadFileDialog()"
    id="UploadFileDialog"
    modalTitle="{{ 'UPLOAD_ATTACHMENT_TITLE' | translate }}"
    acceptButtonLbl="{{ 'OK' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="">
    @if (
      uploadFileModel.fileToUpload !== undefined &&
      uploadFileModel.fileToUpload !== null &&
      uploadFileModel.fileToUpload.size > maxFileUploadSize
    ) {
      <span>
        <label class="px-0 small text-muted red-bold">{{ 'UPLOAD_ATTACHMENT_FILE_SIZE' | translate }}</label>
      </span>
    }
    <div class="row">
      <div class="input-group col-8">
        <input (change)="onFileInput($event)" class="form-control" id="inputGroupFile" type="file" />
        <label
          [attr.data-browse]="'UPLOAD_ATTACHMENT_CHOOSE' | translate"
          class="input-group-text"
          for="inputGroupFile">
          {{ uploadFileModel.filename }}
        </label>
      </div>
    </div>

    @if (isSelectedRecourseType()) {
      <ng-container>
        <label class="px-0 small text-muted">{{ 'UPLOAD_ATTACHMENT_ONLY_PDF_MESSAGE' | translate }}</label>
        <div class="row p-1"></div>
        <div class="row col-5 p-2">
          <h5>
            <b>{{ 'UPLOAD_ATTACHMENT_RECEIVER' | translate }}</b>
          </h5>
        </div>
        <div class="row btn-group form-check">
          <div class="form-check form-check-inline">
            <pas-checkbox
              [(ngModel)]="uploadFileModel.extern"
              [disabled]="externalReceiverCheckboxDisabled"
              (ngModelChange)="onCheckboxChanged()"
              label="{{ 'UPLOAD_ATTACHMENT_RECEIVER_EXTERN' | translate }}"
              size="small"></pas-checkbox>
          </div>
        </div>
      </ng-container>
    }
    @if (isTopicVisible()) {
      <ng-container>
        <div class="row p-1"></div>
        <div class="row col-5 p-2">
          <h5>
            <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TOPIC' | translate }}</b>
          </h5>
        </div>
        <div class="row justify-content-start">
          <pas-select
            [(ngModel)]="uploadFileModel.topic"
            [options]="topicDropdownValues"
            (ngModelChange)="onSelectTopic(fileUploadTopicSelection.selectedOption)"
            class="col-5"
            #fileUploadTopicSelection
            placeholder="{{ 'CHOOSE_ONE' | translate }}"></pas-select>
        </div>
      </ng-container>
    }
  </tur-generic-modal-content>
</ng-template>

<approve-reject-reprocess-dialog></approve-reject-reprocess-dialog>

<ng-template #ModalSpinnerTemplate>
  <pas-spinner [size]="'large'"></pas-spinner>
</ng-template>
